import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button, DatePicker, Spin } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { onShiftDateChange } from '../../API-Interaction/apiServices/kpis.api';
import { getAllPlants, onDropDownChange, onHallChange, onLineChange, onMachineChange, onPlantChange } from '../../API-Interaction/apiServices/plants.api';
import { disabledDate, getFromLocalStorage, isSuperAdminByEmail } from '../../Helpers/helpers';
import { plantList, setPlantsList } from '../../Redux/features/plant.slice';
import { handleSelect, HeaderSelectTitle, pageIds } from '../../Utils/constants';
import {
    checkAccess,
    controlAccess,
    extractRoles,
  } from "../../API-Interaction/apiServices/roles.api";
import ButtonComp from '../ButtonComp/ButtonComp';
import "./DashboardHeader.css"
import { PieChartOutlined, CaretDownOutlined, logo, sidebaruser, MdLogout, favicon, homepage } from '../../Utils/imports';
import { useNavigate } from 'react-router-dom';
import HeaderSelects from './HeaderSelects';
import { TbLayoutSidebarLeftCollapse, TbLayoutSidebarRightCollapse } from "react-icons/tb"
import { pageRoutes } from "../../Routing/pageRoutes";
import AddPlantModal from './AddPlantModal';

function DashboardHeader({ home, collapsed }) {

  const [showAddPlantModal, setShowAddPlantModal] = useState(false);
  const { lists, current } = useSelector((state) => state.plant);
  const selector = useSelector((state) => state);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = getFromLocalStorage("user");
  const [modalTitle, setModalTitle] = useState("Add Machine");
  const isDashboardHeader = true;

    
   const menuItems = [
    {
        key: "0",
        // icon: <img className="sidebarMenuIcon" src={dashboardic} />,
        capability_id: pageIds.home,
        label: "Home",
        // onClick: () => handleNavigation(1, pageRoutes.dashboard),
        route: pageRoutes.oee.homepage,
      },
    {
      key: "1",
      // icon: <img className="sidebarMenuIcon" src={dashboardic} />,
      capability_id: pageIds.dashboard,
      label: "Dashboard",
      // onClick: () => handleNavigation(1, pageRoutes.dashboard),
      route: pageRoutes.dashboard,
    },
    // {
    //   key: "11",
    //   // icon: <img className="sidebarMenuIcon" src={dashboardic} />,
    //   capability_id: pageIds.machineDashboard,
    //   label: "Machine Dashboard",
    //   // onClick: () => handleNavigation(1, pageRoutes.dashboard),
    //   route: pageRoutes.machineDashboard,
    // },
    // {
    //   key: '2',
    //   // icon: <img className="sidebarMenuIcon" src={tasksquare} />,
    //   capability_id: pageIds.plantAveragesView,
    //   label: 'Plant Averages View',
    //   // onClick: () => { },
    //   route: pageRoutes.plantAveragesView
    // },
    {
        key: '2',
        // icon: <img className="sidebarMenuIcon" src={tasksquare} />,
        capability_id: pageIds.linePerfMonitor,
        label: 'Line Perf Moniter',
        // onClick: () => { },
        route: pageRoutes.oee.linePerformanceMonitor
      },
      {
        key: '3',
        // icon: <img className="sidebarMenuIcon" src={tasksquare} />,
        capability_id: pageIds.lineLevelBoard,
        label: 'Line Level Board',
        // onClick: () => { },
        route: pageRoutes.LineLevelBoard,
      },
      {
        key: "4",
        // icon: <img className="sidebarMenuIcon" src={lineBoard} />,
        capability_id: pageIds.lineBoard,
        label: "Line Board",
        // onClick: () => handleNavigation(1, pageRoutes.lineBoard),
        route: pageRoutes.lineBoard,
      },
    {
      key: "5",
      // icon: <img className="sidebarMenuIcon" src={lineopic} />,
      capability_id: pageIds.lineOperator,
      label: "Line Operator",
      // onClick: () => handleNavigation(2, pageRoutes.lineOperator)
      route: pageRoutes.lineOperator,
    },
    /*{
      key: '4',
      // icon: <img className="sidebarMenuIcon" src={setting} />,
      capability_id: pageIds.maintanenceKpis,
      label: 'Maintanence KPIs',
      // onClick: () => { },
      route: pageRoutes.maintanenceKpis
    },*/
    {
      key: "6",
      // icon: <img className="sidebarMenuIcon" src={trenddown} />,
      capability_id: pageIds.downtimeLog,
      label: "Downtime Log",
      // onClick: () => handleNavigation(5, pageRoutes.downtimeLog)
      route: pageRoutes.downtimeLog,
    },
    {
      key: "7",
      // icon: <img className="sidebarMenuIcon" src={linesetting} />,
      capability_id: pageIds.lineSettings,
      label: "Line Settings",
      // onClick: () => handleNavigation(6, pageRoutes.lineSettings),
      route: pageRoutes.lineSettings,
    },
    {
      key: "8",
      // icon: <img className="sidebarMenuIcon" src={plantsetting} />,
      capability_id: pageIds.plantSettings,
      label: "Plant Settings",
      // onClick: () => handleNavigation(5, pageRoutes.plantSettings),
      route: pageRoutes.plantSettings,
    },
    {
      key: '9',
      // icon: <img className="sidebarMenuIcon" src={integration} />,
      capability_id: pageIds.integrations,
      label: 'Integrations',
      // onClick: () => handleNavigation(1, pageRoutes.integrations),
      route: pageRoutes.integrations
    },
    {
      key: '10',
      // icon: <img className="sidebarMenuIcon" src={documenttext} />,
      capability_id: pageIds.auditTrails,
      label: 'Audit Trails',
      // onClick: () => { },
      route: pageRoutes.AuditTrail
    },
    // {
    //     key: '11',
    //     icon: <img className="sidebarMenuIcon" src={documenttext} />,
    //     label: 'Logout',
    //     onClick: () => {
    //         localStorage.clear()
    //         navigate(pageRoutes.login)
    //     }
    // },
  ];


    useEffect(() => {
        getAllPlants(dispatch, selector);
      }, []);
    
      useEffect(() => {
        current?.plant && extractRoles(dispatch, current, user, navigate);
      }, [current?.plant]);
    
      useEffect(() => {
        current?.role && controlAccess(dispatch, current, menuItems, navigate);
      }, [current?.role]);
    
      const { machine = null, line = null } = current;

    const handlePlantChange = async (values, dispatch) => {
      onPlantChange(values, dispatch, setShowAddPlantModal, setModalTitle);
    };
    const handleDropdownChange = async (values, type, dispatch) => {
      onDropDownChange(
        values,
        type,
        dispatch,
        setShowAddPlantModal,
        setModalTitle
      );
    };
    const handleModalClose = () => {
      setShowAddPlantModal(false);
    };

    const lineStatus = {
        "up": <div className='line-up'>up</div>,
        "down": <div className='line-down'>down</div>,
        "disconnected": <div className='line-disconnect'>disconnect</div>,
        "shift ended": <div className='line-up'>shift ended</div>,
    }

    return (
        current?.plant &&
        <div className='headerMainCont'>
        {/* <div className='sidebar_logo'>
        <img src={favicon} style={{ width: "30px", marginLeft: "4px" }} />
        {<img src={logo} />}
    </div> */}
            <div className='HeaderLeft' >
            <div className='sidebar_logo'>
        <img src={favicon} style={{ width: "30px", marginLeft: "4px" }} />
        {<img src={logo} />}
    </div>
                <div className='headSelect'>
                    <span className='headSelect_label'>{HeaderSelectTitle.plant.text}</span>
                    <HeaderSelects
              selectData={{
                options: lists.plants?lists.plants.concat(isSuperAdminByEmail(user.username)?[{
                  _id: "addPlantOption", plantName: "Add Plant" 
                }]:[]):[],
                value: current?.plant?._id,
                onChange: handlePlantChange,
                valueLabel: "plantName",
                idLabel: "_id",
              }}
              isDashboardHeader={isDashboardHeader}
            />
                </div>
            </div>
            <div className='HeaderRight' >
                <div className='headSelect'>
                    <span className='headSelect_label'>{HeaderSelectTitle.hall.text}</span>
                    <HeaderSelects selectData={{ options: lists.halls, value: current?.hall?.index, onChange: onDropDownChange, valueLabel: 'hallName', idLabel: 'index' }} />
                </div>
                <div className='headSelect'>
                    <span className='headSelect_label'>{HeaderSelectTitle.line.text}</span>
                    <HeaderSelects
              selectData={{
                options: (lists.lines && Array.isArray(lists.lines) ? lists.lines : [])
                            .concat(isSuperAdminByEmail(user.username) ? [{ id: "addLineOption", lineName: "Add Line" }] : []),
                value: current?.line?.id,
                onChange: handleDropdownChange,
                valueLabel: "lineName",
                idLabel: "id",
              }}
              isDashboardHeader={isDashboardHeader}
            />
                </div>
                <div className='headSelect'>
                    <span className='headSelect_label'>{HeaderSelectTitle.machine.text}</span>
                    <HeaderSelects
  selectData={{
    options: Array.isArray(lists.machines)
      ? lists.machines.concat(
          isSuperAdminByEmail(user.username)
            ? [
                {
                  machineName: "addMachineOption",
                  displayName: "Add Machine",
                },
              ]
            : []
        )
      : [],
    value: current?.machine?.machineName,
    onChange: handleDropdownChange,
    valueLabel: "displayName",
    idLabel: "machineName",
  }}
  isDashboardHeader={isDashboardHeader}
/>

                </div>
                {showAddPlantModal && (
            <AddPlantModal
              open={showAddPlantModal}
              onClose={handleModalClose}
              title={modalTitle}
            />
          )}
                <div className='line-status-header'>
                    <span className='headSelect_label'>Line Status</span>
                    {lineStatus[current?.line?.status?.status]}
                </div>
            </div>
        </div>
    )
}

export default DashboardHeader